import React, { useState, useEffect, createContext } from 'react';
export const MenuContext = createContext<{activeItem: string}>({activeItem: 'dashboard'});
import { User } from '../../shared/types';
import { Header } from '../../shared/components/Header';
import { Sidebar } from '../../shared/components/Sidebar';
import { SessionRenewalModal } from '../../shared/components/SessionRenewalModal';
import { setSessionExpiredHandler } from '../../shared/lib/axios';

interface MainLayoutProps {
  children: React.ReactNode;
  user: User;
}

export const MainLayout: React.FC<MainLayoutProps & { onSignOut?: () => void }> = ({
  children,
  user,
  onSignOut,
}) => {
  const [activeItem, setActiveItem] = useState('dashboard');
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    setSessionExpiredHandler(() => setSessionExpired(true));
    return () => setSessionExpiredHandler(() => {});
  }, []);

  const handleRenewed = () => {
    setSessionExpired(false);
  };

  const handleSignOut = () => {
    setSessionExpired(false);
    onSignOut?.();
  };

  const handleNavigate = (item: string) => {
    setActiveItem(item);
    console.log('Navegando para:', item);
  };

  return (
    <MenuContext.Provider value={{activeItem}}>
      <div className="min-h-screen bg-gray-50">
        <Header user={user} onSignOut={onSignOut} />
        <div className="flex">
          <Sidebar
            userRole={user.role}
            employmentType={user.employmentType}
            activeItem={activeItem}
            onNavigate={handleNavigate}
          />
          {/*
            `min-w-0` é necessário pra tabelas largas (Custodiários,
            Ativos) confinarem o `overflow-x-auto` no próprio wrapper
            em vez de esticar o main e empurrar o Header/Sidebar. Flex
            items têm min-width: auto por padrão e crescem com o conteúdo.
          */}
          <main className="flex-1 min-w-0">
            {children}
          </main>
        </div>
      </div>

      <SessionRenewalModal
        isOpen={sessionExpired}
        onRenewed={handleRenewed}
        onSignOut={handleSignOut}
      />
    </MenuContext.Provider>
  );
};
